import { DraftReturnSchema } from "@redotech/redo-model/draft-return/draft-return";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const addCustomerDiscountCodes = {
  name: "addCustomerDiscountCodes" as const,
  input: z.object({
    draftReturnId: zExt.objectId(),
    discountCodes: z.array(z.string()),
  }),
  output: z.object({ draftReturn: DraftReturnSchema }),
};
